import { render } from "./px-avatar.vue?vue&type=template&id=54be6eba&scoped=true&ts=true"
import script from "./px-avatar.vue?vue&type=script&lang=ts"
export * from "./px-avatar.vue?vue&type=script&lang=ts"

import "./px-avatar.vue?vue&type=style&index=0&id=54be6eba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54be6eba"]])

export default __exports__